"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EndAge = EndAge;
exports.Interest = Interest;
exports.IssueAge = IssueAge;
exports.IssueAgeCollapse = IssueAgeCollapse;
exports.JointLifeRadioButton = JointLifeRadioButton;
exports.MarketAssumption = MarketAssumption;
exports.MarketGrowthRate = MarketGrowthRate;
exports.NewYorkRadioButton = NewYorkRadioButton;
exports.NonQualifiedRadioButton = NonQualifiedRadioButton;
exports.OtherStateRadioButton = OtherStateRadioButton;
exports.PurchasePayment = PurchasePayment;
exports.PurchasePaymentsCollapse = PurchasePaymentsCollapse;
exports.QualifiedRadioButton = QualifiedRadioButton;
exports.RollUpPeriod = RollUpPeriod;
exports.RollUpRate = RollUpRate;
exports.SingleLifeRadioButton = SingleLifeRadioButton;
exports.StartAge = StartAge;
exports.WithdrawalRate = WithdrawalRate;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _DropdownForForm = require("../Wizard/DropdownForForm");
var _DropdownForNatLangForm = require("../Wizard/DropdownForNatLangForm");
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Collapse controls start here
function IssueAgeCollapse(_ref) {
  var {
    openToStart
  } = _ref;
  // Initialize arrowUpOrDown based on openToStart prop
  var [arrowUpOrDown, setArrowUpOrDown] = (0, _react.useState)(openToStart ? 'up' : 'down');
  var arrowUpOrDownCode = arrowUpOrDown === 'up' ? '0' : '';

  // Handle arrow direction on click (i.e. this will flip the arrow(s)/chevron(s) up and down)
  var handleItemClick = eventKey => () => {
    setArrowUpOrDown(eventKey === 'up' ? 'down' : 'up');
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, {
    defaultActiveKey: arrowUpOrDownCode,
    className: "glwb-collapse"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
    eventKey: "0",
    open: arrowUpOrDownCode === '0' ? true : false,
    onClick: handleItemClick(arrowUpOrDown)
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Issue age limits")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("p", null, "For single life MassMutual Envision contracts with RetirePay, the issue age of the owner (the covered person) must be between 45 and 80.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), "For joint life, enter the age of the youngest covered person (between 45 and 80)."))))));
}
function PurchasePaymentsCollapse(_ref2) {
  var {
    openToStart
  } = _ref2;
  // Initialize arrowUpOrDown based on openToStart prop
  var [arrowUpOrDown, setArrowUpOrDown] = (0, _react.useState)(openToStart ? 'up' : 'down');
  var arrowUpOrDownCode = arrowUpOrDown === 'up' ? '0' : '';

  // Handle arrow direction on click (i.e. this will flip the arrow(s)/chevron(s) up and down)
  var handleItemClick = eventKey => () => {
    setArrowUpOrDown(eventKey === 'up' ? 'down' : 'up');
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, {
    defaultActiveKey: arrowUpOrDownCode,
    className: "glwb-collapse"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
    eventKey: "0",
    open: arrowUpOrDownCode === '0' ? true : false,
    onClick: handleItemClick(arrowUpOrDown)
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Purchase payment limits")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("p", null, "The minimum purchase payment for a MassMutual Envision contract is $5,000 for qualified and $10,000 for non-qualified. The maximum purchase is $1,500,000 without home office approval."))))));
}

// Radio button inputs start here
function SingleLifeRadioButton(props) {
  var {
    setFieldValue,
    isSingleLife
  } = props;
  var fieldName = 'singleLifeRadioButton';
  var id = 'singleLifeRadioBtn';
  var type = 'radio';
  var name = 'glwbVersion';
  var ariaLabel = 'SingleLife';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'field_input', fieldName, 'singleLife');
      setFieldValue('isSingleLife', 'singleLife');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: id,
    name: name,
    className: "custom-control-input",
    required: true,
    checked: isSingleLife === 'singleLife'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "singleLifeRadioBtn"
  }, "Single life")))));
}
function JointLifeRadioButton(props) {
  var {
    setFieldValue,
    isSingleLife
  } = props;
  var fieldName = 'jointLifeRadioButton';
  var type = 'radio';
  var id = 'jointLifeRadioBtn';
  var name = 'glwbVersion';
  var ariaLabel = 'JointLife';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'field_input', fieldName, 'jointLife');
      setFieldValue('isSingleLife', 'jointLife');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: id,
    name: name,
    className: "custom-control-input",
    required: true,
    checked: isSingleLife === 'jointLife'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "jointLifeRadioBtn"
  }, "Joint life")))));
}
function QualifiedRadioButton(props) {
  var {
    setFieldValue,
    isQualified
  } = props;
  var fieldName = 'qualifiedRadioButton';
  var id = 'qualifiedRadioBtn';
  var name = 'qualificationOption';
  var type = 'radio';
  var ariaLabel = 'Qualified';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'field_input', fieldName, 'qualified');
      setFieldValue('isQualified', 'qualified');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: id,
    name: name,
    className: "custom-control-input",
    required: true,
    checked: isQualified === 'qualified'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "qualifiedRadioBtn"
  }, "Qualified")))));
}
function NonQualifiedRadioButton(props) {
  var {
    setFieldValue,
    isQualified
  } = props;
  var fieldName = 'nonQualifiedRadioButton';
  var id = 'nonQualifiedRadioBtn';
  var name = 'qualificationOption';
  var type = 'radio';
  var ariaLabel = 'Non-qualified';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'field_input', fieldName, 'nonQualified');
      setFieldValue('isQualified', 'nonQualified');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: id,
    name: name,
    className: "custom-control-input",
    required: true,
    checked: isQualified === 'nonQualified'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "nonQualifiedRadioBtn"
  }, "Non-qualified")))));
}
function NewYorkRadioButton(props) {
  var {
    setFieldValue,
    isNewYork
  } = props;
  var fieldName = 'newYorkRadioButton';
  var id = 'newYorkRadioBtn';
  var name = 'clientLocation';
  var type = 'radio';
  var ariaLabel = 'NewYork';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'field_input', fieldName, 'newYork');
      setFieldValue('isNewYork', 'newYork');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: id,
    name: name,
    className: "custom-control-input",
    required: true,
    checked: isNewYork === 'newYork'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "newYorkRadioBtn"
  }, "New York")))));
}
function OtherStateRadioButton(props) {
  var {
    setFieldValue,
    isNewYork
  } = props;
  var fieldName = 'otherStateRadioButton';
  var id = 'otherStateRadioBtn';
  var name = 'clientLocation';
  var type = 'radio';
  var ariaLabel = 'OtherState';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'field_input', fieldName, 'otherState');
      setFieldValue('isNewYork', 'otherState');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: id,
    name: name,
    className: "custom-control-input",
    required: true,
    checked: isNewYork === 'otherState'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "otherStateRadioBtn"
  }, "Other state")))));
}

// Text inputs start here
function IssueAge(props) {
  var {
    values,
    errors,
    touched,
    setFieldValue,
    className,
    id
  } = props;
  var fieldName = 'issueAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '2';
  var placeholder = '57';
  var label = '';
  var helperText = 'Enter an age between 45 and 80.';
  var ariaLabel = 'issueAge';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "padding-desktop-left-0 ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: false,
    popoverText: false,
    id: id,
    disabled: false,
    setFieldValue: setFieldValue,
    helperText: helperText,
    ariaLabel: ariaLabel
  }));
}
function PurchasePayment(props) {
  var {
    values,
    errors,
    touched,
    setFieldValue,
    isQualified,
    className,
    id
  } = props;
  var fieldName = 'purchasePayment';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '9';
  var placeholder = '100,000';
  var label = '';
  var helperText = isQualified === 'qualified' ? 'Enter an amount between $5,000 and $1,500,000.' : 'Enter an amount between $10,000 and $1,500,000.';
  var ariaLabel = 'purchasePayment';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "padding-desktop-left-0 ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    popoverText: false,
    id: id,
    disabled: false,
    setFieldValue: setFieldValue,
    helperText: helperText,
    ariaLabel: ariaLabel
  }));
}
function RollUpRate(_ref3) {
  var {
    values,
    setFieldValue
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "rollUpRate",
    values: values,
    dataArray: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.rollUpRate,
    setFieldValue: setFieldValue,
    calcName: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName,
    placeholderText: "Select One"
  });
}
function RollUpPeriod(_ref4) {
  var {
    values,
    setFieldValue
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "rollUpPeriod",
    values: values,
    dataArray: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.rollUpPeriod,
    setFieldValue: setFieldValue,
    calcName: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName,
    placeholderText: "Select One"
  });
}
function Interest(_ref5) {
  var {
    values,
    setFieldValue
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "interestRollUp",
    values: values,
    dataArray: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.interestRollUp,
    setFieldValue: setFieldValue,
    calcName: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName,
    placeholderText: "Select One"
  });
}
function StartAge(_ref6) {
  var _errors$arrayName, _errors$arrayName2, _errors$arrayName3;
  var {
    errors,
    fieldName,
    values,
    arrayName,
    index
  } = _ref6;
  var tealiumName = fieldName + index;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(((_errors$arrayName = errors[arrayName]) === null || _errors$arrayName === void 0 || (_errors$arrayName = _errors$arrayName[index]) === null || _errors$arrayName === void 0 ? void 0 : _errors$arrayName[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: "glwb_startAgeRowId".concat(index),
    type: "text",
    inputMode: "text",
    name: "".concat(arrayName, "[").concat(index, "].startAge"),
    "aria-label": "glwb_startAgeRowId".concat(index),
    maxLength: "2",
    placeholder: "00",
    disabled: true,
    value: values[arrayName][index][fieldName],
    onChange: (0, _formikMiddleware.default)().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, tealiumName).handleBlur()
  })), (_errors$arrayName2 = errors[arrayName]) !== null && _errors$arrayName2 !== void 0 && (_errors$arrayName2 = _errors$arrayName2[index]) !== null && _errors$arrayName2 !== void 0 && _errors$arrayName2[fieldName] ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, (_errors$arrayName3 = errors[arrayName]) === null || _errors$arrayName3 === void 0 || (_errors$arrayName3 = _errors$arrayName3[index]) === null || _errors$arrayName3 === void 0 ? void 0 : _errors$arrayName3[fieldName]) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))));
}
function EndAge(_ref7) {
  var _errors$arrayName4, _errors$arrayName5, _errors$arrayName6;
  var {
    errors,
    fieldName,
    values,
    arrayName,
    index
  } = _ref7;
  var tealiumName = fieldName + index;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(((_errors$arrayName4 = errors[arrayName]) === null || _errors$arrayName4 === void 0 || (_errors$arrayName4 = _errors$arrayName4[index]) === null || _errors$arrayName4 === void 0 ? void 0 : _errors$arrayName4[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: "glwb_endAgeRowId".concat(index),
    type: "text",
    inputMode: "numeric",
    name: "".concat(arrayName, "[").concat(index, "].endAge"),
    "aria-label": "glwb_endAgeRowId".concat(index),
    maxLength: 2,
    placeholder: "00",
    value: values[arrayName][index][fieldName],
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      zeroAlways: false
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, tealiumName).handleBlur()
  })), (_errors$arrayName5 = errors[arrayName]) !== null && _errors$arrayName5 !== void 0 && (_errors$arrayName5 = _errors$arrayName5[index]) !== null && _errors$arrayName5 !== void 0 && _errors$arrayName5[fieldName] ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, (_errors$arrayName6 = errors[arrayName]) === null || _errors$arrayName6 === void 0 || (_errors$arrayName6 = _errors$arrayName6[index]) === null || _errors$arrayName6 === void 0 ? void 0 : _errors$arrayName6[fieldName]) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))));
}
function WithdrawalRate(_ref8) {
  var _errors$arrayName7, _errors$arrayName8, _errors$arrayName9;
  var {
    errors,
    fieldName,
    values,
    arrayName,
    index
  } = _ref8;
  var tealiumName = fieldName + index;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-7 col-sm-6 col-md-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(((_errors$arrayName7 = errors[arrayName]) === null || _errors$arrayName7 === void 0 || (_errors$arrayName7 = _errors$arrayName7[index]) === null || _errors$arrayName7 === void 0 ? void 0 : _errors$arrayName7[fieldName]) && 'is-invalid'),
    disabled: values[arrayName][index][fieldName] === 0 ? true : false
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: "glwb_withdrawalRateId".concat(index),
    "aria-label": "glwb_withdrawalRateId".concat(index),
    type: "text",
    inputMode: "numeric",
    maxLength: 5,
    name: "".concat(arrayName, "[").concat(index, "].withdrawalRate"),
    placeholder: "0.00",
    disabled: values[arrayName][index][fieldName] === 0 ? true : false,
    value: values[arrayName][index][fieldName],
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, tealiumName).handleBlur()
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, "%"))), (_errors$arrayName8 = errors[arrayName]) !== null && _errors$arrayName8 !== void 0 && (_errors$arrayName8 = _errors$arrayName8[index]) !== null && _errors$arrayName8 !== void 0 && _errors$arrayName8[fieldName] ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, (_errors$arrayName9 = errors[arrayName]) === null || _errors$arrayName9 === void 0 || (_errors$arrayName9 = _errors$arrayName9[index]) === null || _errors$arrayName9 === void 0 ? void 0 : _errors$arrayName9[fieldName]) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))));
}
function MarketAssumption(props) {
  var {
    values,
    errors,
    touched,
    setFieldValue
  } = props;
  var fieldName = 'net_market_growth_rate';
  var preText = ' Net growth ';

  // pre-set 'dropdownValue' in case there is an issue with the radio button
  // from a previous screen that sets isNewYork
  var dropdownArray = _GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.netGrowthNonNYArray;

  // 'isNewYork' is value from a previous screen
  if (values.isNewYork === 'newYork') {
    dropdownArray = _GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.netGrowthNYArray;
  }
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    id: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.idPrefix + fieldName,
    dropdownArray: dropdownArray,
    fieldName: fieldName,
    setFieldValue: setFieldValue,
    preText: preText,
    calcName: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName,
    errors: errors,
    touched: touched
  });
}
function MarketGrowthRate(_ref9) {
  var {
    values,
    setFieldValue
  } = _ref9;
  var fieldName = 'net_market_growth_rate';
  var preText = 'Select net market growth: ';
  var postText = ' ';
  var dropdownArray = _GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.netGrowthNonNYArray;
  if (!(0, _lodash.isEmpty)(values.isNewYork) && !(0, _lodash.isNull)(values.isNewYork)) {
    // 'isNewYork' is value from a previous screen
    if (values.isNewYork === 'newYork') {
      dropdownArray = _GuaranteedLifetimeWithdrawalBenefitWizardCalc.dropdownOptions.netGrowthNYArray;
    }
  }
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: dropdownArray,
    fieldName: fieldName,
    preText: preText,
    postText: postText,
    setFieldValue: setFieldValue,
    calcName: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName
  });
}